import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PATH_LISTAGEM_DOACOES, PATH_LISTAGEM_ENTIDADES, PATH_LISTAGEM_OFICIOS } from 'constants/index';
import ListaOficios from 'pages/centralDoacoes/listaOficios/listaOficios';
import ListaDoacoes from '../../centralDoacoes/listaDoacoes/listaDoacoes.page';
import ListaEntidade from '../../centralDoacoes/listaEntidades/listaEntidades.page';
import Tab from '../../../components/Tabs/tabs.component';


export default class TabNavigation extends Component {
	state = {
		activeTab: '',
	};

	/*
		Primeiro item das tabs, ao carregar a página
	*/
	componentDidMount() {
		const url = window.location.href.substr(window.location.href);
		const tab = url.split('/');
		const tamanho = tab.length - 1;
		this.setState({
			activeTab: tab[tamanho],
		});
	}

	/*
		Muda o conteudo e estilo da tab, de acordo com o clique
	*/
	handleClick = (valor) => {
		const { history } = this.props;

		this.setState({
			activeTab: valor,
		});

		history.push(`/centralDoacoes/${valor}`);
	};

	/*
		Funções para saber se os caminhos são da listagem entidades e doações, caso não for nenhuma
		das duas, não exibe a tab navigation na central de doações.
		Foi implementada para retirar a tab navigation, por exemplo,
		quando o usuário clicar em gerenciar item
	*/
	isDoacao() {
		const { history } = this.props;
		const isDoacao = history.location.pathname === PATH_LISTAGEM_DOACOES;
		return isDoacao;
	}

	isEntidade() {
		const { history } = this.props;
		const isEntidade = history.location.pathname === PATH_LISTAGEM_ENTIDADES;
		return isEntidade;
	}

	isOficio() {
		const { history } = this.props;
		const isOficio = history.location.pathname === PATH_LISTAGEM_OFICIOS;
		return isOficio;
	}

	render() {
		const { match: { path } } = this.props;
		const { activeTab } = this.state;

		return (
			(this.isDoacao() || this.isEntidade() || this.isOficio()) && (
				<div className='card container mt-5'>
					<div className='card-body'>
						<div className='tabs custom-tab'>
							<nav className='doacao'>
								<ul>
									<Tab
										label='Estoque'
										valor='listaDoacoes'
										activeTab={activeTab}
										onClick={() => this.handleClick('listaDoacoes')}
										icon='doacao'

									/>
									<Tab
										label='Entidades'
										valor='listaEntidades'
										activeTab={activeTab}
										onClick={() => this.handleClick('listaEntidades')}
										icon='entidade'
									/>
									<Tab
										label='Ofícios'
										valor='listaOficios'
										activeTab={activeTab}
										onClick={() => this.handleClick('listaOficios')}
										icon='oficio'
									/>
								</ul>
							</nav>
							<div>
								<Switch>
									<Route
										path={`${path}/listaDoacoes`}
										component={ListaDoacoes}
									/>
									<Route
										path={`${path}/listaEntidades`}
										component={ListaEntidade}
									/>
									<Route
										path={`${path}/listaOficios`}
										component={ListaOficios}
									/>
								</Switch>
							</div>
						</div>
					</div>
				</div>
			)
		);
	}
}
